import * as React from 'react';
import DownloadContext from 'contexts/DownloadContext';
import { Dropdown } from '@symphony-ui/uitoolkit-components';
import ApiServerURL from 'models/ApiServerUrl';
import ApiServerRequest from 'models/ApiServerRequest';
import { sendFetchError } from 'utils/messageUtils';
import TableSettingsButton from './TableSettingsButton';
import TableSettings from 'models/TableSettings';
const TableSettingsElement = function TableSettingsFunction({ current, setCurrent, table }) {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const [tableSettingsOptions, setTableSettingsOptions] = React.useState([]);
    const [original, setOriginal] = React.useState();
    const onChangeTableSettings = React.useCallback((event) => {
        const { value } = event.target.value;
        (async () => {
            const url = new ApiServerURL('/syndicate/table-settings/find');
            url.searchParams.append('id', value);
            const request = new ApiServerRequest(url);
            try {
                const body = await apiFetchJson(request);
                const updated = new TableSettings(body);
                setCurrent(updated);
                setOriginal(updated);
            }
            catch (error) {
                sendFetchError('Unable to download table options', error, request);
            }
        })();
    }, [apiFetchJson, setCurrent]);
    React.useEffect(() => {
        const { id } = current;
        if (id !== undefined && original?.id !== id) {
            (async () => {
                const url = new ApiServerURL('/syndicate/table-settings/find');
                url.searchParams.append('id', id);
                const request = new ApiServerRequest(url);
                try {
                    const body = await apiFetchJson(request);
                    const updated = new TableSettings(body);
                    setOriginal(updated);
                }
                catch (error) {
                    sendFetchError('Unable to download table options', error, request);
                }
            })();
        }
    }, [apiFetchJson, current, original?.id]);
    React.useEffect(() => {
        const abortController = new AbortController();
        (async () => {
            const url = new ApiServerURL('/syndicate/table-settings/options');
            url.searchParams.append('name', current.table);
            const request = new ApiServerRequest(url);
            try {
                const body = await apiFetchJson(request, abortController.signal);
                setTableSettingsOptions(body);
            }
            catch (error) {
                sendFetchError('Unable to download table options', error, request);
            }
        })();
        return () => abortController.abort();
    }, [apiFetchJson, current.table]);
    const isAmended = React.useMemo(() => original !== undefined && !current.equals(original), [current, original]);
    const realOptions = React.useMemo(() => {
        return tableSettingsOptions.map(o => isAmended && 'value' in o && o.value === current.id ? { label: o.label + " (amended)", value: o.value } : o);
    }, [current.id, tableSettingsOptions, isAmended]);
    return (React.createElement(React.Fragment, null,
        realOptions.length > 0 ?
            React.createElement("div", { style: { width: '24rem' } },
                React.createElement(Dropdown, { label: "Table Settings", onChange: onChangeTableSettings, options: realOptions, value: realOptions.find((o) => 'value' in o && o.value === current.id) })) : undefined,
        React.createElement(TableSettingsButton, { current: current, original: original, setCurrent: setCurrent, setOriginal: setOriginal, table: table })));
};
export default TableSettingsElement;
